export class ToSignUpViewBloc {
  clickToSignUpButton() {
    let url = window.location.href;
    if (url.includes("/editor/shared_intelligent_app")) {
      url = window.location.href.replace("/editor/shared_intelligent_app", "/editor/sign_up");
    } else {
      url = window.location.href.replace("/editor", "/signup");
    }
    window.history.pushState({}, "", url);
  }
}
